
<div class="form-group flex-content pb-2" 
     [hidden]="getHidden()" 
     [id]="getId()">
  <div class="input-container d-flex " 
       [ngClass]="{
        'border-principal' : this.getBorder(),
        'border-principal-family flex-column align-items-start' : containFamily(),
        'align-items-center' : !containFamily()
       }"
       [ngStyle]="{
        'background-color' : this.getRadioBackgroundColor()
      }">
    <div class="d-flex align-items-center">
      <div>
        <input #inputCheckbox
               type=radio 
               class="toggle radio-label"
                [ngClass]="{
                  'ms-2': getBorder(),
                  'pointer': !getReadOnly()
                }"              
               [name]="getFamilyValue()" 
               (change)="this.onCheckboxChange()"
               [value]="getValue()" 
               [disabled]="getReadOnly()"
               (click)="this.executeEvent()">
      </div>
  
      <label class="radio-description-container" 
              [ngClass]="{
                'center-Title' : getDescriptionValue()=== '',
                'border-botton-none' : !containFamily(),
                'title-family' : containFamily(),
                'd-flex flex-column align-items-start' : !containFamily(),
                'radio-des-container-no-family': containFamily()
              }">
        <label class="bs-h3-radio th-text-main">{{getLabelValue()}}</label>
        <label class="bs-paragraph th-text-gray-paragraphs ">{{getDescriptionValue()}}</label>
      </label>
    </div>

    <div class="grid-container w-100"
         *ngIf="containFamily()">
      <div class="tab">
        <hr class="w-100 m-0 mb-4 p-0" *ngIf="isContentVisible">
        <ng-container #target></ng-container>
      </div>
    </div>
    
    <div class="radio-receipt-container w-100 flex-wrap d-flex align-items-center th-bg-border-line-background"
        *ngIf="this.getIsRadioReceipt()"
        [ngClass]="{
          'pt-3 pb-3' : this.isExtraSmall
        }">
      <div [ngClass]="{
        'ms-5' : this.isSmall || this.isMedium,
        'ms-4': this.isExtraSmall
      }">
        <span class="bs-placeholder th-text-main fw-bold">Saldo disponible: </span>
      </div>
      <div class="d-flex align-items-center justify-content-end me-5" [ngClass]="{
        'ms-auto' : this.isSmall || this.isMedium,
        'ms-5' : this.isExtraSmall
      }">
        <div class="me-3">
          <ng-container #amountInputRadioReceipt></ng-container>
        </div>
        <div>
          <ng-container #buttonRadioReceipt></ng-container>
        </div>
      </div>
    </div>
  </div>
</div>